export const generateTimeOptions = (): Date[] => {
  const dates: Date[] = [];
  const startOfDay = new Date();
  startOfDay.setHours(0, 0, 0, 0);

  for (let i = 0; i < 24; i++) {
    const date = new Date(startOfDay);
    date.setHours(i);
    dates.push(date);
  }

  return dates;
};